import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "content-centered large"
  }, [!_vm.$whitelabel.MyOrdersListCustomerFiltersHidden ? _c("div", {
    staticClass: "search-global-container"
  }, [_c("div", {
    staticClass: "search-top-buttons"
  }, [_vm.canImportOrder ? _c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.importOrder();
      }
    }
  }, [_c(VIcon, {
    staticClass: "icon-import-order",
    attrs: {
      dark: ""
    }
  }, [_vm._v("fas fa-file-upload")]), _vm._v(" Import order ")], 1) : _vm._e()], 1), _c("div", {
    staticClass: "search-main-line"
  }, [_c("div", {
    staticClass: "search-main-text-field"
  }, [_c(VTextField, {
    attrs: {
      solo: "",
      placeholder: "Search for an order reference (...001)",
      clearable: "",
      "hide-details": "auto",
      loading: _vm.dataLoading,
      "append-icon": "fa-search"
    },
    on: {
      blur: function blur($event) {
        !!_vm.formSearch.label && _vm.search(true);
      },
      "click:append": function clickAppend($event) {
        return _vm.search(true);
      },
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.search(true);
      },
      "click:clear": function clickClear() {
        _vm.formSearch.label = null;
        _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.label,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "label", $$v);
      },
      expression: "formSearch.label"
    }
  })], 1), _c("div", {
    staticClass: "search-pagination-limit"
  }, [_c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch.paging, "limits", $$v);
      },
      expression: "formSearch.paging.limits"
    }
  })], 1)]), _c("div", {
    staticClass: "search-table-top"
  }, [_c("div", {
    staticClass: "search-other-fields"
  }, [_c("div", {
    staticClass: "search-with-range-date"
  }, [_c(VAutocomplete, {
    attrs: {
      items: _vm.sortBy,
      "item-value": "id",
      "item-text": "label",
      label: "Sort by",
      solo: "",
      "hide-details": "auto",
      clearable: ""
    },
    on: {
      change: function change($event) {
        return _vm.changeSortBy();
      }
    },
    model: {
      value: _vm.formSearch.sort_by,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "sort_by", $$v);
      },
      expression: "formSearch.sort_by"
    }
  }), _vm.formSearch.sort_by === "RANGE_DATE" ? _c("div", [_c(VMenu, {
    ref: "sortByRangeDatesMenu",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.formSearch.range_date,
      transition: "scale-transition",
      "offset-y": "",
      "read-only": "",
      "min-width": "auto"
    },
    on: {
      "update:returnValue": function updateReturnValue($event) {
        return _vm.$set(_vm.formSearch, "range_date", $event);
      },
      "update:return-value": function updateReturnValue($event) {
        return _vm.$set(_vm.formSearch, "range_date", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c(VCombobox, _vm._g(_vm._b({
          staticClass: "mt-small-2",
          attrs: {
            clearable: "",
            multiple: "",
            chips: "",
            "small-chips": "",
            solo: "",
            label: "Select two dates in range",
            "prepend-icon": "mdi-calendar",
            "hide-details": "auto"
          },
          on: {
            "click:clear": function clickClear($event) {
              return _vm.clearDateRange();
            }
          },
          model: {
            value: _vm.rangeDatesDisplay,
            callback: function callback($$v) {
              _vm.rangeDatesDisplay = $$v;
            },
            expression: "rangeDatesDisplay"
          }
        }, "v-combobox", attrs, false), on))];
      }
    }], null, false, 325252599),
    model: {
      value: _vm.sortByRangeDatesMenu,
      callback: function callback($$v) {
        _vm.sortByRangeDatesMenu = $$v;
      },
      expression: "sortByRangeDatesMenu"
    }
  }, [_c(VDatePicker, {
    attrs: {
      multiple: "",
      "no-title": "",
      scrollable: "",
      range: ""
    },
    on: {
      change: function change($event) {
        return _vm.formatDates();
      }
    },
    model: {
      value: _vm.formSearch.range_date,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch, "range_date", $$v);
      },
      expression: "formSearch.range_date"
    }
  }, [_c(VSpacer), _c(VBtn, {
    attrs: {
      text: "",
      color: "primary"
    },
    on: {
      click: function click($event) {
        _vm.sortByRangeDatesMenu = false;
      }
    }
  }, [_vm._v("Cancel")]), _c(VBtn, {
    attrs: {
      text: "",
      color: "primary"
    },
    on: {
      click: function click($event) {
        _vm.$refs.sortByRangeDatesMenu.save(_vm.formSearch.range_date), _vm.sortByDatesRanges();
      }
    }
  }, [_vm._v(" OK ")])], 1)], 1)], 1) : _vm._e()], 1), _c("div", {
    staticClass: "tags"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringToValidate ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("to_validate");
      }
    }
  }, [_vm._v(" In validation ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringInPreparation ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("in_preparation");
      }
    }
  }, [_vm._v(" In preparation ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringInTransit ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("in_transit");
      }
    }
  }, [_vm._v(" In delivery ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringHeld ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("held");
      }
    }
  }, [_vm._v(" Held ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringDelivered ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("delivered");
      }
    }
  }, [_vm._v(" Delivered ")]), _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    class: _vm.isFilteringCancelled ? "highlight" : "",
    on: {
      click: function click($event) {
        return _vm.fastFilter("cancelled");
      }
    }
  }, [_vm._v(" Cancelled ")]), _vm.isFilteringStatus ? _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    on: {
      click: _vm.clearFiltersStatus
    }
  }, [_vm._v(" Clear all "), _c(VIcon, {
    attrs: {
      small: ""
    }
  }, [_vm._v("mdi-close")])], 1) : _c(VBtn, {
    staticClass: "dfwa-btn --small-1-5 secondary",
    on: {
      click: _vm.fillFiltersStatus
    }
  }, [_vm._v(" Add all "), _c(VIcon, {
    attrs: {
      small: ""
    }
  }, [_vm._v("mdi-plus")])], 1)], 1)]), _c("div", {
    staticClass: "search-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: _vm.formSearch.paging.currentPage,
      limits: Number(_vm.formSearch.paging.limits),
      totalNumber: _vm.baseModel.numberOfOrders
    }
  })], 1)])]) : _vm._e(), _c("div", {
    staticClass: "list-container"
  }, [_vm.baseModel.orders.length == 0 && !_vm.dataLoading ? _c("div", {
    staticClass: "list-empty"
  }, [_vm._v(" No orders available. ")]) : _vm._e(), _c("div", {
    staticClass: "list-container-items-not-table"
  }, _vm._l(_vm.baseModel.orders, function (order) {
    return _c("div", {
      key: "main_container_".concat(order.id_order),
      staticClass: "list-order"
    }, [_c("router-link", {
      staticClass: "router-link --no-hover-underlined",
      attrs: {
        to: _vm.orderDetails(order.id_order)
      }
    }, [_c("div", {
      class: [_vm.orderStatus.find(function (x) {
        return x.status == order.status;
      }), "list-order-main"]
    }, [_c("div", {
      staticClass: "list-order-main-firstline"
    }, [_c("div", {
      staticClass: "list-order-main-firstline-number"
    }, [_vm._v(" Order N° " + _vm._s(order.reference_order.shorterReference()) + " ")]), !order.is_destination_inbound && !order.isStockTransfer && order.status != _vm.orderStatus.find(function (x) {
      return x.id == "CANCELLED";
    }).status && (order.payment_state === _vm.paymentState.SUCCEEDED || order.payment_state === _vm.paymentState.FAILED) ? _c("PaymentBadge", {
      attrs: {
        state: order.payment_state,
        date: order.payment_date,
        textStyle: "capitalize",
        suffix: order.buyer_term && order.payment_state === _vm.paymentState.DEFERRED ? "- ".concat(_vm.listTerms.find(function (x) {
          return x.id === order.buyer_term;
        }).name) : null
      }
    }) : _vm._e(), _vm.mustBeFinalizedOrders[order.id_order] ? _c("div", {
      staticClass: "badge warning text-transform:none"
    }, [_vm._v(" " + _vm._s(order.status == _vm.orderStatus.find(function (x) {
      return x.id == "ADJUSTING";
    }).status ? "Waiting for action" : "You should approve this order") + " "), _c("i", {
      staticClass: "fas fa-pause-circle"
    })]) : _vm._e(), !order.isFullyCalculatedAmounts ? _c("div", [_c(VMenu, {
      attrs: {
        "open-on-hover": "",
        top: "",
        "offset-y": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref2) {
          var on = _ref2.on,
            attrs = _ref2.attrs;
          return [_c(VIcon, _vm._g(_vm._b({
            attrs: {
              color: "orange darken-2"
            }
          }, "v-icon", attrs, false), on), [_vm._v("mdi-alert")])];
        }
      }], null, true)
    }, [_c(VCard, {
      staticClass: "pa-2 text-sm"
    }, [_vm._v(" This order is being updated, the amount may be inaccurate ")])], 1)], 1) : _vm._e()], 1), _c("div", {
      staticClass: "list-order-main-secondline"
    }, [_vm.isImporterInvoiceConsultable(order) ? [_vm._v(" " + _vm._s(order.importerInvoiceNumberLabel) + " ")] : _vm.isInvoiceConsultable(order) ? [_vm._v(" " + _vm._s(order.invoiceNumberLabel) + " ")] : _vm.hasBeenValidated(order) && order.isPreventInvoice ? [_vm._v(" " + _vm._s(_vm.getOrderConfirmationReference(order)) + " ")] : _vm._e()], 2), _c("div", {
      staticClass: "list-container-items-not-table-linedata list-order-main-data"
    }, [_c("div", {
      staticClass: "list-order-main-data-status"
    }, [_c("div", {
      staticClass: "data-title"
    }, [_vm._v("Status")]), _c("div", {
      staticClass: "data-value"
    }, [_c("img", {
      staticClass: "status-icon",
      attrs: {
        src: _vm.getOrderStatusIcon(order.status),
        title: [_vm.orderStatus.find(function (x) {
          return x.status == order.status;
        }).value],
        alt: ""
      }
    }), _c("div", [_c("div", {
      staticClass: "status-label"
    }, [_vm._v(" " + _vm._s(_vm.orderStatus.find(function (x) {
      return x.status == order.status;
    }).valueBuyer) + " ")]), _c("div", {
      staticClass: "statusLastDate"
    }, [_vm._v(" (" + _vm._s(_vm._f("formatDate")(order.lastStatusUpdateDate)) + ") ")])])])]), _c("div", {
      staticClass: "list-order-main-data-address"
    }, [_c("div", {
      staticClass: "data-title"
    }, [_vm._v("Delivery address")]), _c("div", {
      staticClass: "data-value"
    }, [!order.is_destination_inbound && !order.isStockTransfer ? _c("div", {
      staticClass: "text-left"
    }, [_c("div", [_vm._v(_vm._s(order.delivery_address.street))]), order.delivery_address.address_line_2 ? _c("div", [_vm._v(" " + _vm._s(order.delivery_address.address_line_2) + " ")]) : _vm._e(), order.delivery_address.address_line_3 ? _c("div", [_vm._v(" " + _vm._s(order.delivery_address.address_line_3) + " ")]) : _vm._e(), order.delivery_address.address_complement ? _c("div", [_vm._v(" " + _vm._s(order.delivery_address.address_complement) + ", ")]) : _vm._e(), _c("div", [_vm._v(_vm._s(order.delivery_address.city) + " " + _vm._s(order.delivery_address.zip))]), _c("div", [_vm._v(_vm._s(order.delivery_address.country.country_label))])]) : _c("div", [_c("div", [_vm._v("Inbound warehouse")])])])]), _c("div", {
      staticClass: "list-order-main-data-quantity"
    }, [_c("div", {
      staticClass: "data-title"
    }, [_vm._v("Quantity")]), _c("div", {
      staticClass: "data-value"
    }, [_vm._v(" " + _vm._s(order.quantity) + " item" + _vm._s(order.quantity > 1 ? "s" : "") + " ")])]), _c("div", {
      staticClass: "list-order-main-data-date"
    }, [_c("div", {
      staticClass: "data-title"
    }, [_vm._v("Order date")]), _c("div", {
      staticClass: "data-value"
    }, [_vm._v(" " + _vm._s(_vm._f("formatDate")(order.date_order)) + " ")])]), _c("div", {
      staticClass: "list-order-main-data-total"
    }, [_c("div", {
      staticClass: "data-title"
    }, [_vm._v("Total")]), _c("div", {
      staticClass: "data-value"
    }, [_vm._v(" " + _vm._s(_vm.formatPrice(order.total_amount_currency)) + " " + _vm._s(_vm.getSymbolCurrency(order.currency)) + " ")])])])])])], 1);
  }), 0)]), !_vm.$whitelabel.MyOrdersCustomerSearchAndPaginationHidden && _vm.baseModel.numberOfPages >= 2 ? _c("div", {
    staticClass: "table-bottom-container"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-paging"
  }, [_c("paging", {
    attrs: {
      numberOfPages: _vm.baseModel.numberOfPages,
      currentPage: _vm.formSearch.paging.currentPage
    },
    on: {
      changePage: _vm.changePage
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-right"
  }, [_c("div", {
    staticClass: "table-bottom-pagination-limit"
  }, [_c(VSelect, {
    staticClass: "paging-limits-select",
    attrs: {
      items: _vm.pagingLimitsChoices,
      solo: "",
      "hide-details": "auto"
    },
    on: {
      change: function change($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.formSearch.paging.limits,
      callback: function callback($$v) {
        _vm.$set(_vm.formSearch.paging, "limits", $$v);
      },
      expression: "formSearch.paging.limits"
    }
  })], 1), _c("div", {
    staticClass: "table-bottom-pagination-index"
  }, [_c("index", {
    attrs: {
      currentPage: _vm.formSearch.paging.currentPage,
      limits: Number(_vm.formSearch.paging.limits),
      totalNumber: _vm.baseModel.numberOfOrders
    }
  })], 1)])]) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  }), _c("ImportOrderDialogVue", {
    attrs: {
      loggedUserData: _vm.loggedUserData
    },
    model: {
      value: _vm.isImportOrderShown,
      callback: function callback($$v) {
        _vm.isImportOrderShown = $$v;
      },
      expression: "isImportOrderShown"
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };